import { AssetValues } from "services/asset-management/AssetGradingService";

const PERCENT = 100;
const UPLIFT_PERCENTAGE_DECIMALS = 1;
const AMOUNT_FORMATTER = new Intl.NumberFormat("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export function totalEstimatedValue(values: AssetValues): number {
    return values.value + values.upliftValue;
}

export function upliftPercentage(values: AssetValues): number | undefined {
    if (values.value === 0) {
        return undefined;
    }
    return (values.upliftValue / values.value) * PERCENT;
}

export function formatUpliftPercentage(percentage: number): string {
    return `+${percentage.toFixed(UPLIFT_PERCENTAGE_DECIMALS)}%`;
}

export function formatGroupedAmount(amount: number): string {
    return AMOUNT_FORMATTER.format(amount);
}

export function formatAssetValue(value: unknown, upliftValue?: unknown): string | undefined {
    if (!value) {
        return undefined;
    }
    const total = Number(value) + Number(upliftValue ?? 0);
    if (!Number.isFinite(total)) {
        return "$" + value;
    }
    return "$" + AMOUNT_FORMATTER.format(total);
}
